import React, { useEffect, useState, useMemo } from "react";
import { Link, useNavigate } from "react-router-dom";
import { getCountdown } from "../helper/Countdown";
import toast from "react-hot-toast";
import productData from "../data/products.json";

const DealsOne = () => {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);

  // 🔹 Same image handling style as ShopInner
  const getImage = (item) => {
    if (!item) return "/assets/img/placeholder.png";

    if (Array.isArray(item.imageUrl) && item.imageUrl.length > 0) {
      return item.imageUrl[0]; // first base64 image
    }

    if (typeof item.imageUrl === "string" && item.imageUrl.trim()) {
      return item.imageUrl;
    }

    return "/assets/img/placeholder.png";
  };

  useEffect(() => {
    setProducts(productData);
  }, []);

  // 🔹 Countdown (kept as in your code)
  const [timeLeft, setTimeLeft] = useState(getCountdown());
  useEffect(() => {
    const interval = setInterval(() => setTimeLeft(getCountdown()), 1000);
    return () => clearInterval(interval);
  }, []);

  // 🔹 Add to cart with session check (same logic as ShopInner)
  const handleAddToCart = (product) => {
    const isLoggedIn = sessionStorage.getItem("isLoggedIn");

    if (isLoggedIn !== "true") {
      toast.error("Please login first!");
      navigate("/login-now");
      return;
    }

    let cart = JSON.parse(sessionStorage.getItem("cart")) || [];
    const existing = cart.find((item) => item.id === product.id);

    if (existing) {
      existing.quantity++;
    } else {
      cart.push({ ...product, quantity: 1 });
    }

    sessionStorage.setItem("cart", JSON.stringify(cart));

    // 🔥 Trigger header update instantly (fixes no-refresh issue)
    window.dispatchEvent(new Event("cart-updated"));

    toast.success(`${product.name} added to cart!`);
  };

  const formatCategory = (str) =>
    str.replace(/[-_]/g, " ").replace(/\b\w/g, (l) => l.toUpperCase());

  // 🔹 Add rating / tags like before (no extra drama)
  const productsWithRandomData = useMemo(() => {
    return products.map((item) => {
      const rating = (Math.random() * 1 + 4).toFixed(1); // 4.0–5.0
      const reviews = Math.floor(Math.random() * 400) + 100;
      const tagPool = [
        "Wireless",
        "Fast Print",
        "Best Seller",
        "Eco Mode",
        "Smart Print",
      ];
      const features = tagPool.sort(() => 0.5 - Math.random()).slice(0, 2);

      return {
        ...item,
        rating,
        reviews,
        features,
        formattedCategory: formatCategory(item.category || "Printer"),
      };
    });
  }, [products]);

  return (
    <section className="deals-weeek pt-30 pb-30 sec-grey">
      <div className="container container-lg">
        <div className="p-24 text-center mb-30">
          <h4 style={{ fontSize: "32px", fontWeight: "700", color: "#222" }}>
            Best Printers Deals For You Only
          </h4>
          <p
            style={{
              color: "#555",
              fontSize: "15px",
              maxWidth: "700px",
              margin: "10px auto",
              lineHeight: "1.7",
            }}
          >
            Save on the most trusted printers across the globe with fast
            delivery, genuine supplies and expert guidance.
          </p>
        </div>

        {/* PRODUCT GRID */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
            gap: "25px",
            marginBottom: "40px",
          }}
        >
          {productsWithRandomData.map((item) => (
            <div key={item.id} className="deal-card">
              <Link to={`/product-details/${item.id}`} className="card-image">
                <img src={getImage(item)} alt={item.name} loading="lazy" />
                <span className="badge">🔥 Trending</span>
              </Link>

              <div className="card-content">
                <p className="card-category">{item.formattedCategory}</p>

                <Link to={`/product-details/${item.id}`} className="card-title">
                  {item.name}
                </Link>

                <p className="card-description">
                  {item.description
                    ? item.description.split(" ").slice(0, 12).join(" ") + "..."
                    : ""}
                </p>

                <div className="card-tags">
                  {item.features.map((tag, i) => (
                    <span key={i} className="tag">
                      {tag}
                    </span>
                  ))}
                </div>

                <div className="card-footer">
                  <div>
                    <span className="price">${item.price}</span>
                  </div>

                  <button
                    className="cart-btn"
                    onClick={() => handleAddToCart(item)}
                  >
                    Add <i className="ph ph-shopping-cart" />
                  </button>
                </div>

                <div className="card-rating">
                  <span className="stars">⭐ {item.rating}</span>
                  <span className="stock">✔ In Stock</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* === INLINE STYLING === */}
      <style>{`
        /* ==== GRID CARD BASE STYLE ==== */
.deal-card {
  background: #fff;
  border-radius: 18px;
  overflow: hidden;
  box-shadow: 0px 8px 20px rgba(0,0,0,0.06);
  transition: all 0.25s ease;
  cursor: pointer;
  display: flex;
  flex-direction: column;
}

.deal-card:hover {
  transform: translateY(-6px);
  box-shadow: 0px 14px 28px rgba(0,0,0,0.12);
}

/* ==== IMAGE SECTION ==== */
.card-image {
  position: relative;
  background: #fff;
  padding: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 230px;
  overflow: hidden;
}

.card-image img {
  width: 70%;
  transition: 0.35s ease-in-out;
}

.deal-card:hover img {
  transform: scale(1.08);
}

/* BATCH / TAG */
.badge {
  position: absolute;
  top: 12px;
  right: 14px;
  background: #ff4141;
  color: white;
  padding: 6px 12px;
  border-radius: 16px;
  font-size: 11px;
  font-weight: bold;
  min-width:100px!important;
}


/* ==== CONTENT WRAPPER ==== */
.card-content {
  padding: 22px;
  flex-grow: 1;
  background: #fafbfc;
}

.card-category {
  font-size: 11px;
  color: #777;
  font-weight: 600;
  margin-bottom: 6px;
  letter-spacing: .4px;
}

/* PRODUCT TITLE */
.card-title {
  text-decoration: none;
  color: #111;
  font-weight: 700;
  font-size: 18px;
  display: block;
  line-height: 1.4;
  margin-bottom: 10px;
}

.card-description {
  font-size: 13px;
  color: #666;
  margin-bottom: 15px;
  line-height: 1.5;
}

/* TAGS */
.card-tags {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 18px;
}

.card-tags .tag {
  background: #eaf2ff;
  color: #0b61d6;
  font-size: 10px;
  padding: 6px 10px;
  border-radius: 10px;
  font-weight: 600;
  white-space: nowrap;
}

/* ==== FOOTER AREA ==== */
.card-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
}

.price {
  font-size: 22px;
  font-weight: 800;
}

/* BUTTON */
.cart-btn {
  background: #0b61d6;
  border: none;
  padding: 10px 18px;
  border-radius: 10px;
  color: white;
  font-size: 13px;
  font-weight: 600;
  transition: 0.25s ease;
}

.cart-btn i {
  margin-left: 5px;
  font-size: 15px;
}

.cart-btn:hover {
  background: #084db1;
  transform: translateY(-2px);
}

/* ==== RATING & STOCK ==== */
.card-rating {
  border-top: 1px solid #ddd;
  padding-top: 12px;
  display: flex;
  justify-content: space-between;
  font-size: 13px;
}

.stars {
  color: #ffb400;
}

.stock {
  color: #0ca52a;
  font-weight: bold;
}


/* ===== RESPONSIVE ===== */
@media (max-width: 768px) {
  .card-image img {
    width: 80%;
  }

  .deal-card {
    border-radius: 14px;
  }
}

      `}</style>
    </section>
  );
};

export default DealsOne;
